import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Router} from '@angular/router';
import {RoleService} from './role.service';
import {LoginApiRequest} from '../models/requests/login-api-request';
import {Observable, throwError} from 'rxjs';
import {LoginApiResponse} from '../models/responses/login-api-response';
import {ErrorCode} from '../models/errors/error-code';
import {catchError} from 'rxjs/operators';
import {User} from '../models/entities/user';
import {PermissionService} from './permission.service';

@Injectable({providedIn: 'root'})
export class AuthService {
  private apiUrl = environment.apiUrl;
  private apiToken = environment.apiToken;
  private expirationTime: any;
  public loggedIn = false;

  constructor(private http: HttpClient,
              private router: Router,
              private roleService: RoleService,
              private permissionService: PermissionService) {
  }

  public login(request: LoginApiRequest): Observable<LoginApiResponse> {
    return this.http.post<LoginApiResponse>(`${this.apiUrl}/login`, request)
      .pipe(catchError(this.handleError));
  }

  public changePassword(loginRequest): Observable<any> {
    return this.http.post(`${this.apiUrl}/profile/change-password`, loginRequest);
  }

  public me(): Observable<User> {
    return this.http.post<User>(`${this.apiUrl}/me`, {});
  }

  public authorize(tokenResp: LoginApiResponse) {
    localStorage.setItem(this.apiToken, tokenResp.token);
    this.putRole(tokenResp.role);
    this.router.navigateByUrl('/');
    this.loggedIn = true;
    // this.autoLogout(tokenResp.expires_in * 1000);
  }

  public putRole(role) {
    localStorage.setItem('role', role);
  }

  public getRole() {
    return localStorage.getItem('role');
  }

  public removeRole() {
    localStorage.removeItem('role');
  }

  public checkAvailability(): boolean {
    return !!localStorage.getItem(this.apiToken);
  }

  removeToken() {
    localStorage.removeItem(this.apiToken);
  }

  public getToken() {
    return localStorage.getItem(this.apiToken);
  }

  logout() {
    this.removeRole();
    this.removeToken();
    this.loggedIn = false;
    this.permissionService.clearPermissions();
    this.router.navigateByUrl('/auth/login');
  }

  private handleError(error: HttpErrorResponse) {
    let message = 'Неизвестная ошибка';
    if (!error.error) {
      return throwError(message);
    } else {
      if (error.error.errorCode === ErrorCode.UNAUTHORIZED) {
        message = 'Неправильный email или пароль';
      }
      return throwError(message);
    }
  }
}
